import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.find";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { loading, validateRuleData } from '@/decorators';

var AddEditModal = function (_super) {
  __extends(AddEditModal, _super);

  function AddEditModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.formDataRule = {};
    _this.loading = false;
    _this.billDataTitleLoading = false;
    _this.formData = _this.initFormData();
    _this.colSpan = 4;
    _this.billDataTitleList = [];
    _this.editAccountCode = true;
    _this.isTaxNoRequired = false;
    return _this;
  }

  AddEditModal.prototype.getConfirmRuleData = function (data) {
    this.formDataRule = this.$util.mergeValidate(data, {});
  };

  AddEditModal.prototype.initFormData = function (data) {
    if (data) {
      return data;
    }

    return {
      account_code: '',
      address: '',
      open_bank_account: '',
      open_bank_name: '',
      phone: '',
      tax_no: '',
      title: '',
      bill_type: undefined
    };
  };

  AddEditModal.prototype.addBillData = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.finance.addBillData(param)];

          case 1:
            _a.sent();

            this.$message.success(this.t('操作成功'));
            return [2];
        }
      });
    });
  };

  AddEditModal.prototype.editBillData = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.finance.editBillData(param)];

          case 1:
            _a.sent();

            this.$message.success(this.t('保存成功'));
            return [2];
        }
      });
    });
  };

  AddEditModal.prototype.queryBillDataTitleList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.finance.queryBillDataTitleList()];

          case 1:
            data = _a.sent().data;
            console.log(data);
            this.billDataTitleList = data;
            return [2];
        }
      });
    });
  };

  AddEditModal.prototype.updateTitle = function (accountCode) {
    var accountItem = this.billDataTitleList.find(function (item) {
      return item.account_code === accountCode;
    });

    if (!accountItem) {
      return;
    }

    this.formData.title = accountItem.sign_body_name;
  };

  AddEditModal.prototype.handleAccountCodeChange = function (accountCode) {
    var accountItem = this.billDataTitleList.find(function (item) {
      return item.account_code === accountCode;
    });

    if (!accountItem) {
      accountItem = {};
    }

    var company_address = accountItem.company_address,
        phone_number = accountItem.phone_number,
        open_bank_name = accountItem.open_bank_name,
        bank_account = accountItem.bank_account,
        sign_body_name = accountItem.sign_body_name,
        credit_code = accountItem.credit_code,
        bill_type = accountItem.bill_type,
        is_tax_no_required = accountItem.is_tax_no_required;
    Object.assign(this.formData, {
      address: company_address,
      open_bank_account: bank_account,
      open_bank_name: open_bank_name,
      phone: phone_number,
      tax_no: credit_code,
      title: sign_body_name,
      bill_type: bill_type
    });
    this.isTaxNoRequired = is_tax_no_required;
  };

  AddEditModal.prototype.handleClickAccountCodeEdit = function () {
    this.editAccountCode = true;
  };

  AddEditModal.prototype.handleSave = function () {
    return __awaiter(this, void 0, Promise, function () {
      var formDataRef, res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            formDataRef = this.$refs.formDataRef;
            return [4, formDataRef.validate()];

          case 1:
            res = _a.sent();

            if (!res) {
              return [2];
            }

            if (this.isTaxNoRequired && this.$util.isEmpty(this.formData.tax_no)) {
              this.$message.warning($t("\u8BF7\u8054\u7CFB\u5BA2\u670D\u7EF4\u62A4\u793E\u4F1A\u4FE1\u606F\u4EE3\u7801/\u7A0E\u52A1\u767B\u8BB0\u53F7"));
              return [2];
            }

            if (!this.formData.str_id) return [3, 3];
            this.updateTitle(this.formData.account_code);
            return [4, this.editBillData(this.formData)];

          case 2:
            _a.sent();

            return [3, 5];

          case 3:
            return [4, this.addBillData(this.formData)];

          case 4:
            _a.sent();

            _a.label = 5;

          case 5:
            this.$emit('success');
            this.$emit('update:visible', false);
            return [2];
        }
      });
    });
  };

  AddEditModal.prototype.handleClose = function () {
    this.$emit('update:visible', false);
  };

  AddEditModal.prototype.created = function () {};

  AddEditModal.prototype.handleVisibleChange = function () {
    return __awaiter(this, void 0, void 0, function () {
      var formDataRef;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.visible) return [3, 2];
            this.formData = this.initFormData(this.$util.deepCopy(this.rowData.data));

            if (this.rowData.type === this.$enum.common.ModalTypeEnum.EDIT) {
              this.editAccountCode = false;
            }

            return [4, this.queryBillDataTitleList()];

          case 1:
            _a.sent();

            this.handleAccountCodeChange(this.formData.account_code);
            return [3, 3];

          case 2:
            formDataRef = this.$refs.formDataRef;
            formDataRef && formDataRef.clearValidate();
            this.isTaxNoRequired = false;
            _a.label = 3;

          case 3:
            return [2];
        }
      });
    });
  };

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], AddEditModal.prototype, "visible", void 0);

  __decorate([Prop({})], AddEditModal.prototype, "rowData", void 0);

  __decorate([validateRuleData('/api/v1/finance/bill_data/create')], AddEditModal.prototype, "getConfirmRuleData", null);

  __decorate([loading('loading')], AddEditModal.prototype, "addBillData", null);

  __decorate([loading('loading')], AddEditModal.prototype, "editBillData", null);

  __decorate([loading('billDataTitleLoading')], AddEditModal.prototype, "queryBillDataTitleList", null);

  __decorate([Watch('visible', {
    deep: true,
    immediate: true
  })], AddEditModal.prototype, "handleVisibleChange", null);

  AddEditModal = __decorate([Component], AddEditModal);
  return AddEditModal;
}(Vue);

export default AddEditModal;